import React, { Component } from "react";
import {
  Box,
  Text,
  Stack,
  InputGroup,
  InputLeftAddon,
  Input,
  Button,
  Collapse,
  InputRightElement,
  Textarea,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton
} from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlay, faCopy } from "@fortawesome/free-solid-svg-icons";
import { formatISO, add } from "date-fns";
import { JsonViewer } from '@textea/json-viewer'

import ConfigService from "../../services/ConfigService";
import LocalStorageService from "../../services/LocalStorageService";
import CoreService from "../../services/CoreService";

import HistorySearchStrip from "../ObsHome/Components/HistorySearchStrip";

import ObsSearchParams from "../../models/ObsSearchParams";




export default class DataApiInstructionsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      canCopyToClipboard: true,
      searchParams: new ObsSearchParams(),
      searchParamsKey: null,
      authTokenUrl: "",
      searchUrl: "",
      dimSearchUrl: "",
      token: "",
      jsonResult: null,
      showJsonBox: false,
      jsonBoxUrl: "",
      jsonBoxTitle: ""
    };

    this.configService = new ConfigService();
    this.localStorageService = new LocalStorageService();
    this.coreService = new CoreService();

    this.onSearchParamsChange = this.onSearchParamsChange.bind(this);
    this.toSearchUrl = this.toSearchUrl.bind(this);
    this.callEndpoint = this.callEndpoint.bind(this);
    this.copyToClipboard = this.copyToClipboard.bind(this);
    this.toggleJsonBox = this.toggleJsonBox.bind(this);

    this.makeSection = this.makeSection.bind(this);

  }

  async componentDidMount() {
    var searchParams;
    var hasGlobalSearchParams = this.props.globalSearchParams;
    if (hasGlobalSearchParams) {
      searchParams = this.props.globalSearchParams;
    }
    else {
      searchParams = new ObsSearchParams();
      searchParams.schemaId = this.props.userSession.currentSchemaId;
      //searchParams.location = this.props.userSession.currentLocationId;
      //searchParams.observer = this.props.userSession.uid;
      searchParams.eventStartDate = formatISO(add(new Date(), { days: -5 }));
      searchParams.eventEndDate = formatISO(add(new Date(), { days: 1 }));
    }
    var searchKey = ObsSearchParams.toSearchKey(searchParams);
    var searchUrl = this.toSearchUrl(searchKey);
    var childSearchUrl = this.toChildSearchUrl(searchKey);
    var dimSearchUrl = this.toDimSearchUrl(searchParams.schemaId, searchKey);

    var authTokenUrl = this.toAuthTokenUrl();

    //var scopesResult = await this.authResourceService.getScopesByRoles(this.configService.getDataApiRole(), this.props.userSession.token);

    this.setState({ currentSchemaId: searchParams.schemaId, authTokenUrl: authTokenUrl, searchUrl: searchUrl, childSearchUrl: childSearchUrl, dimSearchUrl: dimSearchUrl, token: this.props.userSession.token, searchParams: searchParams, searchParamsKey: searchKey })
  }

  copyToClipboard(txt)
  {
    console.log("Copying to clipboard");
    navigator.clipboard.writeText(txt);
    this.props.onToastRequest("info", "copied to clipboard", 1000);
  }
  

  async callEndpoint(url) {
    var response = await this.coreService.fetchEndpoint(url, this.props.userSession.token);
    this.setState({ jsonResult: response, jsonBoxUrl: url, showJsonBox: true });
  }

  toggleJsonBox()
  {
    var showJsonBox = (!this.state.showJsonBox);
    this.setState({showJsonBox: showJsonBox});
  }


  onSearchParamsChange(newSearchParams) {
    var searchKey = ObsSearchParams.toSearchKey(newSearchParams);
    var searchUrl = this.toSearchUrl(searchKey);
    var childSearchUrl = this.toChildSearchUrl(searchKey);
    var dimSearchUrl = this.toDimSearchUrl(newSearchParams.schemaId, searchKey);
    this.setState({ searchUrl: searchUrl, childSearchUrl: childSearchUrl, dimSearchUrl: dimSearchUrl, searchParams: newSearchParams, searchParamsKey: searchKey });
    // DO NOT use this to change other search params
    //this.props.onGlobalSearchParamsChange(newSearchParams, this.props.parentComponent);

  }

  toAuthTokenUrl() {
    var result = this.configService.getAuthServiceHost() + "/connect/token";
    return result;
  }

  toSearchUrl(searchKey) {
    var result = this.configService.getDataApiServiceHost() + "/api/dataapi/gcid/" + this.props.userSession.gcid + "/observationfact/{apiTable}?" + searchKey;
    return result;
  }

  toChildSearchUrl(searchKey) {
    var result = this.configService.getDataApiServiceHost() + "/api/dataapi/gcid/" + this.props.userSession.gcid + "/observationchildfact/facttype/{factType}?" + searchKey;
    return result;
  }

  toDimSearchUrl(schemaId, searchKey) {
    var result = this.configService.getDataApiServiceHost() + "/api/dataapi/gcid/" + this.props.userSession.gcid + "/observationdimension/schemaid/" + schemaId + "/dimlevel/{dimLevel}";
    return result;
  }

  makeSection(url, title) {
    return <div style={{width: "45vw"}}>

      <Text color="white">{title}</Text>
      <Box >
        <Textarea
          value={url}
          bg='white'
        />
        <Button
          variant="solid"
          leftIcon={<FontAwesomeIcon icon={faCopy} />}
          bg='#0095c8'
          color='white'
          fontSize={{ base: '12px', md: '14px', lg: '18px' }}
          onClick={() => this.copyToClipboard(url) }
          margin='5px'
        >
          copy
        </Button>
        <Button
          variant="solid"
          leftIcon={<FontAwesomeIcon icon={faCirclePlay} />}
          bg='#0095c8'
          color='white'
          fontSize={{ base: '12px', md: '14px', lg: '18px' }}
          onClick={() => { this.callEndpoint(url) }}
        >
          try
        </Button>
      </Box>
      {/* 
      <InputGroup>
        <InputLeftAddon children='GET' />
        <Input value={url} bg='white' />
      </InputGroup> */}

    </div>
  }

  render() {

    const flatFactUrl = this.state.searchUrl.replace("{apiTable}", "ObservationFlatFact");
    const mainFactUrl = this.state.searchUrl.replace("{apiTable}", "ObservationFact");
    const categoryFactUrl = this.state.searchUrl.replace("{apiTable}", "ObservationCategoryFact");
    const defectFactUrl = this.state.searchUrl.replace("{apiTable}", "ObservationDefectFact");
    const categoryDimUrl = this.state.dimSearchUrl.replace("{dimLevel}", "Category");
    const defectDimUrl = this.state.dimSearchUrl.replace("{dimLevel}", "Defect");

    const tokenHeader = 'Content-Type: application/x-www-form-urlencoded';
    const tokenUrlBody = "grant_type=client_credentials&client_id=" + this.props.userSession.uid + "&client_secret=<your password>&scope=auth.role.reader obs.app.user obs.datalist.reader obs.observation.reader obs.orgconfig.reader obs.schema.reader";


    return (

      <div className='main'>

        <Modal isOpen={this.state.showJsonBox} onClose={this.toggleJsonBox}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>{this.state.jsonBoxTitle}</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              {(this.state.jsonResult) ?
                <JsonViewer value={this.state.jsonResult} />
                : <span />
              }

            </ModalBody>
          </ModalContent>
        </Modal>

        <Box bgColor='#0a597e' borderRadius='5px' width='100%' padding='20px'>
          <Text fontSize={{ base: '30px', md: '36px', lg: '40px' }} color='white'>Data API Access</Text>

          <Box
            width={'35vw'}
            marginBottom={'20px'}
          >
            {(this.state.currentSchemaId) &&
              <HistorySearchStrip
                userSession={this.props.userSession}
                currentSchemaId={this.state.currentSchemaId}
                searchParams={this.state.searchParams}
                onSearchParamsChange={this.onSearchParamsChange}
                onErrorPageRequest={this.props.onErrorPageRequest}
                parentComponent={"DataApiAccess"}
              />
            }
          </Box>

          <Stack spacing={3} >
            <Text color="white">Acquire a bearer token to call API Endpoints</Text>

            <Box display={'flex'} justifyContent={'space-evenly'} marginBottom={'10px'}>

              <Box width={'30vw'}>
                <Textarea
                  size='md'
                  resize='vertical'
                  value={tokenHeader}
                  bg='white'
                />
                {(this.state.canCopyToClipboard) &&
                  <Button
                    variant="solid"
                    leftIcon={<FontAwesomeIcon icon={faCopy} />}
                    bg='#0095c8'
                    color='white'
                    fontSize={{ base: '12px', md: '14px', lg: '18px' }}
                    onClick={() => this.copyToClipboard(tokenHeader) }
                    marginTop='5px'
                  >
                    copy header
                  </Button>
                }
              </Box>

              <Box width={'30vw'}>
                <Textarea
                  size='md'
                  resize='vertical'
                  value={tokenUrlBody}
                  bg='white'
                />
                {(this.state.canCopyToClipboard) &&
                  <Button
                    variant="solid"
                    leftIcon={<FontAwesomeIcon icon={faCopy} />}
                    bg='#0095c8'
                    color='white'
                    fontSize={{ base: '12px', md: '14px', lg: '18px' }}
                    onClick={() => this.copyToClipboard(tokenUrlBody) }
                    marginTop='5px'
                  >
                    copy body
                  </Button>
                }
              </Box>

              <Box width={'30vw'}>
                <Textarea
                  size='md'
                  resize='vertical'
                  value={this.state.authTokenUrl}
                  bg='white'
                />
                {(this.state.canCopyToClipboard) &&
                  <Button
                    variant="solid"
                    leftIcon={<FontAwesomeIcon icon={faCopy} />}
                    bg='#0095c8'
                    color='white'
                    fontSize={{ base: '12px', md: '14px', lg: '18px' }}
                    onClick={() => { this.copyToClipboard(this.state.authTokenUrl) }}
                    marginTop='5px'

                  >
                    copy post
                  </Button>
                }
              </Box>
            </Box>

            <Text color="white" fontSize={'28px'} >Data API Endpoints</Text>

            {/* TBD - Remy - can we make this a "collapsible" section that starts collapsed, but expands if the user uses the "try" button?  */}
            {/* {(this.state.jsonResult) ?
              <Box bg="grey" border="2px" borderColor="white">
                <Button size='sm' onClick={() => this.toggleJsonBox()}>{this.state.showJsonBox ? "collapse" : "expand"}</Button>
                <InputGroup>
                  <InputLeftAddon children='Result' />
                  <Input value={this.state.jsonBoxUrl} />
                </InputGroup>
                {(this.state.showJsonBox) ?
                  <Box bg='lightgrey' w='100%' p={4} color='white' border="1px" borderColor="white">
                    <JsonViewer value={this.state.jsonResult} />
                  </Box>
                  : <span />
                }
              </Box>

              : <span />
            } */}

            <Box display={'flex'} flexDirection={'row'} flexWrap={'wrap'} justifyContent={'space-evenly'}>
              {this.makeSection(flatFactUrl, "Flat Observation Endpoint (Observations in a single flattened file)")}

              {this.makeSection(mainFactUrl, "Observation Main Fact Endpoint (Main fact data for star dimensional analysis)")}

              {this.makeSection(categoryFactUrl, "Observation Category Fact Endpoint (Category fact data for star dimensional analysis)")}

              {this.makeSection(defectFactUrl, "Observation Defect Fact Endpoint (Defect fact data for star dimensional analysis)")}

              {this.makeSection(categoryDimUrl, "Observation Category Dimension Endpoint (Dimension data for star dimensional analysis)")}

              {this.makeSection(defectDimUrl, "Observation Defect Dimension Endpoint (Dimension data for star dimensional analysis)")}
            </Box>
          </Stack>
        </Box>
      </div >
    );
  }
}
